<template><div><h1>VUX V2.5.12 released</h1>
<h2><a href="/en/components/form-preview.html">FormPreview</a></h2>
<ul><li>[fix] Fix layout issue when header-value is empty #1935</li>
</ul>
<h2><a href="/en/components/inline-calendar.html">InlineCalendar</a></h2>
<ul><li>[feature] add method:switchViewToToday switchViewToMonth</li>
<li>[feature] support event:on-view-change</li>
</ul>
<h2><a href="/en/components/popup.html">Popup</a></h2>
<ul><li>[fix] clean vux-modal-open on beforeDestroy and deactivated #1921</li>
</ul>
<h2><a href="/en/components/x-dialog.html">XDialog</a></h2>
<ul><li>[change] prop:scroll is deprecated #1858 #1877</li>
</ul>
<h2><a href="/en/components/datetime.html">Datetime</a></h2>
<ul><li>[fix] Fix datetime show multiple times #1927</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.5.12 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.5.12-123.vue?ff5b22b6